/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import { querySelectorAllInIframes } from './project-shopping.util';

/**
 *
 * @param {string} projectId Project Shopping id
 * @returns {object}
 */
function useProjectShopping(projectId) {
  const [showPortal, setShowPortal] = useState(false);
  const [portalNode, setPortalNode] = useState(null);
  const storedProjectId = useRef();
  storedProjectId.current = projectId;
  // TODO when testing your own pre-releases, be sure to set this to true or else you will have to fire a lifecycle event manually to view project shopping in the ATC drawer.
  const isTntActive = useRef(false);
  const fromBSSDrawer = useRef(false);
  const isB2C = useRef(false);
  const isB2B = useRef(false);

  const cartAddCallback = () => {
    // Check if project shopping should show in ATC drawer
    if (storedProjectId.current && isTntActive.current && isB2C.current && !isB2B.current) {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('ps.project-shopping-analytics');

      // Hide all bss drawers.
      if (!fromBSSDrawer.current) {
        const bssFrames = document.querySelectorAll('iframe[src*="/cart/bss"]');
        [...bssFrames].map((frame) => frame?.parentElement?.style?.setProperty('width', '0px'));
      }
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('ps.show-project-shopping', 1);
    }
  };

  useEffect(() => {
    isB2C.current = window.THDCustomer?.default?.isB2CCustomer;
    isB2B.current = window.THDCustomer?.default?.isB2BCustomer;

    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('tnt.toggle-project-shopping', (data) => {
      isTntActive.current = !!data.output;
    });

    window.LIFE_CYCLE_EVENT_BUS.on('cart.add-to-cart', () => {
      fromBSSDrawer.current = false;
      cartAddCallback();
    });

    window.LIFE_CYCLE_EVENT_BUS.on('bssDrawer.*', (data) => {
      if (data.eventName !== 'open') return null;
      const bssFrames = document.querySelectorAll('iframe[src*="/cart/bss"]');
      // Place event listener on every found bss iframe
      for (let i = 0; i < bssFrames?.length; i += 1) {
        const bssWindow = bssFrames[i]?.contentWindow;
        bssWindow.LIFE_CYCLE_EVENT_BUS.on('cart.add-to-cart', () => {
          fromBSSDrawer.current = true;
          cartAddCallback();
        });
      }
      return null;
    });

    window.LIFE_CYCLE_EVENT_BUS.on('ATCdrawer.mounted', () => {
      const fetchedPortalNode = querySelectorAllInIframes('#project-shopping-portal', fromBSSDrawer.current);

      if (!fetchedPortalNode) {
        setShowPortal(false);
        return setPortalNode(null);
      }

      // clear out the project shopping node first
      fetchedPortalNode.textContent = '';

      // Grab all style sheets from parent document and place them inside iframe
      // TODO Remove stylesheets when cart is migrated to Nucleus or utility css exists across apps
      const stylesheets = document?.querySelectorAll('link[href*="/experiences/"][type="text/css"]');
      Object.values(stylesheets).map((sheet) => {
        const clonedSheet = sheet.cloneNode();
        return fetchedPortalNode.append(clonedSheet);
      });

      // Turn on portal
      setPortalNode(fetchedPortalNode);
      return setShowPortal(true);
    });

    return () => {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.off('tnt.toggle-project-shopping');
    };
  }, []);

  return { showPortal, portalNode };
}

export { useProjectShopping };
